import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import { withDevtools } from './middleware-utils';

export interface TransactionLimits {
  daily: number;
  monthly: number;
  perTransaction: number;
  currency: string;
}

export interface TransactionLimitsUsage {
  daily: number;
  monthly: number;
  lastReset: string; // ISO date
}

interface TransactionLimitsStore {
  // State
  limits: TransactionLimits | null;
  usage: TransactionLimitsUsage | null;
  isLoading: boolean;
  lastFetched: number | null;

  // Actions
  setLimits: (limits: TransactionLimits, usage: TransactionLimitsUsage) => void;
  setLoading: (loading: boolean) => void;
  markAsStale: () => void;
  reset: () => void;
}

export const useTransactionLimitsStore = create<TransactionLimitsStore>()(
  withDevtools(
    'TransactionLimits',
    persist(
      set => ({
        limits: null,
        usage: null,
        isLoading: false,
        lastFetched: null,

        setLimits: (limits, usage) =>
          set({
            limits,
            usage,
            lastFetched: Date.now(),
            isLoading: false,
          }),

        setLoading: loading => set({ isLoading: loading }),

        markAsStale: () => set({ lastFetched: 0 }),

        reset: () =>
          set({
            limits: null,
            usage: null,
            isLoading: false,
            lastFetched: null,
          }),
      }),
      {
        name: 'tankef:transaction-limits',
        storage: createJSONStorage(() => sessionStorage),
      }
    )
  )
);
